import React, { HTMLAttributes } from 'react';

interface IPropertiesCategoryBadge {
  text: string;
  selected?: boolean;
  onClick?: HTMLAttributes<HTMLDivElement>['onClick'];
}

const Badge = ({ text, onClick, selected }: IPropertiesCategoryBadge) => (
  <div
    onClick={onClick}
    className={` w-fit rounded-full transition-[filter] duration-200 ${
      selected
        ? 'bg-theme-white text-theme-black'
        : 'bg-theme-gray text-theme-white hover:brightness-[1.2]'
    }  leading-6 text-sm px-3 py-1 cursor-pointer`}
  >
    {text}
  </div>
);

export default Badge;
